export class SendLinktoCustomerReq {
  agentCode: string;
  ckycNo: string;
  customerName: string;
  email: string;
  mobile: string;
  nameOfTheKycDocuement: string;
  premium: string;
  quoteNumber: string;
  smsType: string;
  subline: string;
  uniqueId: string;
}

export class SendLinkRes {
  status: string;
  statusCode: string;
  result: any;
  error: any;
}

export class GenerateLinkReq {
  returnURL: string;
	uniqueId: string;
	customerType: string;
	panNumber: string;
	dateOfBirth: string;
	appName: string;
	emailId: string;
	mobileNo: string;
}

export class GenerateLinkRes {
  returnURL: string;
	url: string;
	kycRefNo: string;
	uniqueId: string;
	kycDetails: any;
	apiStatus: string;
	kycStatus: boolean;
	errMsg: string;
	errorCode: string;
}
